/**
 * RedRock Monitoring Admin BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FacilityByIdUserResponse } from './facility-by-id-user-response';


export interface FacilityByIdResponse { 
    id: string;
    name: string;
    powerCapacity?: number;
    subnet?: string | null;
    manager?: FacilityByIdUserResponse;
    deputyManager?: FacilityByIdUserResponse;
    technicians?: Array<FacilityByIdUserResponse> | null;
}

